import { HOME_PAGE } from "./constants";
import i18n from "../i18n";

// Some browsers (Safari private browsing on older iOS, in-app webviews with
// storage disabled) expose `window.localStorage` as null or throw on access
// instead of just failing individual calls, so every read/write below is
// guarded rather than assuming `localStorage` is always a usable object.
function safeGetItem(key){
    try {
        return localStorage ? localStorage.getItem(key) : null;
    } catch (e) {
        return null;
    }
}

function safeSetItem(key, value){
    try {
        if (localStorage) localStorage.setItem(key, value);
    } catch (e) {
        // storage unavailable (private browsing, quota, disabled) - ignore
    }
}

function safeClear(){
    try {
        if (localStorage) localStorage.clear();
    } catch (e) {
        // storage unavailable - ignore
    }
}

export function setUser(user){
    safeSetItem("user", user);
}

export function getUser(){
    return safeGetItem("user");
}

export function setToken(token){
    safeSetItem("token", token);
}

export function getToken(){
    return safeGetItem("token");
}

export function setKey(key){
    safeSetItem("key", key);
}

export function getKey(){
    return safeGetItem("key");
}

export function clearStorage(){
    safeClear();
}

export function logout(){
    safeClear();
}

export function getUserName(){
    const user = JSON.parse(getUser());
    return user?.firstName+" "+user?.lastName;
}

// SEO-friendly salon-detail URL: prefer the business's domain slug (subDomain),
// falling back to the numeric id for businesses that haven't set one yet.
export function getSalonDetailUrl(business){
    const slug = business?.subDomain;
    const id = business?.id;
    return `/salon-detail/${slug || id}`;
}

/**
 * Booking runs on its own subdomain, so it doesn't share localStorage with
 * the marketplace. Pass the visitor's current language as `?lang=` so
 * booking can pick it up and save it to its own localStorage on load.
 */
export function getBookingUrl(subDomain, website){
    if (!subDomain) return website;
    const lang = (i18n.language || "en").split("-")[0];
    return "https://" + subDomain + ".retainoo.com/?lang=" + lang;
}
